export function OutlineLongitudeIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20.1342C16.4914 20.1342 20.1325 16.4931 20.1325 12.0017C20.1325 7.5102 16.4914 3.86914 12 3.86914C7.50849 3.86914 3.86743 7.5102 3.86743 12.0017C3.86743 16.4931 7.50849 20.1342 12 20.1342Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M12 16.2703C16.4914 16.2703 20.1325 14.3595 20.1325 12.0023C20.1325 9.6452 16.4914 7.73438 12 7.73438C7.50849 7.73438 3.86743 9.6452 3.86743 12.0023C3.86743 14.3595 7.50849 16.2703 12 16.2703Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M20.1326 12.002H3.91089"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}
